<div class="pageWrapper">
  <div class="statIcons">

        <div class="imageWrapper yearsOfService">
          <img loading="lazy" src="https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/cscBranchDirectory%2Fcorporate%2FmiscImages%2Fyears_of_service56.png?alt=media&token=57b579f7-bb14-4e16-adb3-5857f9ba279a" alt="Years of Service" />
          <p class="statText">Years of Service</p>
        </div>
        <div class="imageWrapper branchesNationwide">
          <img loading="lazy" src="https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/cscBranchDirectory%2Fcorporate%2FmiscImages%2Fbranch_locations.png?alt=media&token=354b7b08-e9f9-45be-9ccd-a785bb334b6f" alt="48+ Branches Nationwide" />
          <p class="statText">48+ Branches Nationwide</p>
        </div>
        <div class="imageWrapper citiesServed">
          <img loading="lazy" src="https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/cscBranchDirectory%2Fcorporate%2FmiscImages%2Fcities_served.png?alt=media&token=110f9cfb-2a91-4ad5-8e99-f4f83ad598e7" alt="200+ Cities Served" />
          <p class="statText">200+ Cities Served</p>
        </div>


        <div class="imageWrapper eventsAnnually">
          <img loading="lazy" src="https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/cscBranchDirectory%2Fcorporate%2FmiscImages%2Fevents.png?alt=media&token=6eff8324-6cef-4686-900a-fca1c98b3007" alt="25,000+ Events Annually" />
           <p class="statText">25,000+ Events Annually</p>
        </div>
        <div class="imageWrapper patronsServed">
          <img loading="lazy" src="https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/cscBranchDirectory%2Fcorporate%2FmiscImages%2Fpatrons_served_annually.png?alt=media&token=3908580d-bb16-4675-9a35-7f33c19e5275" alt="Millions of Patrons Served Annually" />
          <p class="statText">Millions of Patrons Served Annually</p>
        </div>

        <div class="imageWrapper teamMembers">
          <img loading="lazy" src="https://firebasestorage.googleapis.com/v0/b/csc-usa-prod.appspot.com/o/cscBranchDirectory%2Fcorporate%2FmiscImages%2Fteam_members.png?alt=media&token=713465e3-7a40-4b89-b081-a684c94fcba4" alt="60,000 Trained Team Members" />
          <p class="statText">60,000 Trained Team Members</p>
        </div>
  </div>
</div>
